"use client";
import React, { useMemo, lazy } from "react"
import {Link} from '@/lib/target';

const BangkeoAllLeague = lazy(() => import('@/components/client/BangkeoAllLeague'));
const NoDataWithLink = lazy(() => import('@/components/client/NoDataWithLink'));

// Memoize the no data content to prevent unnecessary re-renders
const NoDataContent = React.memo(() => (
  <span>
    Hôm nay chưa có trận đấu Trực Tuyến nào. Khám phá thêm các trận qua
    Lịch thi đấu
    <Link
      className="text-medium-blue hover:cursor-pointer"
      href={"/lich-thi-dau"}
    >
      &nbsp;tại đây.
    </Link>
  </span>
));

const BangkeoAllMatches = ({ matches }) => {
  const matchesList = useMemo(() => {
    if (!matches.length) return null;
    
    return matches.map((match) => (
      <BangkeoAllLeague
        type="tc"
        key={match.id || `${match.homeTeam}-${match.awayTeam}-${match.startTime}`} // Assuming these properties exist
        match={match}
      />
    ));
  }, [matches]);

  if (!matches.length) {
    return (
      <NoDataWithLink>
        <NoDataContent />
      </NoDataWithLink>
    );
  }

  return matchesList;
};

export default React.memo(BangkeoAllMatches);
